export default "__VITE_ASSET__DFpyfowe__"